module.exports = {
  AudioCue: {
    config: "Configuration",
    PluginName: "Audio Cue",
    AutoPlay: "Autoplay",
    URL: "Audio URL",
    Image: "Image URL",
    Color: "Color",
    UseImage: "Use an image",
    HideAnimation: "Hide animation",
    PlayerView: "Player view",
    IsSoundRecord: "Record Sound",
    SoundRecorder: "Passing Time",
    Start: "Start",
    Stop: "Stop",
    SoundRecording: "Sound Recording...",
    SoundRecorded: "Sound Recorded.",
    SelectSoundProvider: "Add Audio Track",
    AddSound: "Add",
    EndTime: "End Time on Slide",
    StartTime: "Start Time on Slide",
    Save: "Save",
  },
};
